'use strict';

module.exports = {
    // Pass the viewTracking object
    viewAttributes: (viewTracking) => {
        if (!isEmpty(viewTracking)) {
            return { "data-viewport": viewTracking };
        }
    },

    generateViewAttribute: () => {
        return { "data-viewport": { "trackableId": ulid()} };
    },

    // Pass the trackList array 
    interactionAttributes: (trackingList) => {
        let attributesValues = [];
        if (!isEmpty(trackingList) && Array.isArray(trackingList)) {
            trackingList.forEach(function (trackingItem, index) {
                if (trackingItem.eventAction == "ACTN") {
                    if (!isEmpty(trackingItem.eventProperty) && !isEmpty(trackingItem.eventProperty.interaction))
                        attributesValues.push({
                            "actionKind": trackingItem.actionKind || 'CLICK',
                            "interaction": trackingItem.eventProperty.interaction
                        });
                }
            });
        }
        return (attributesValues.length > 0) ? { "data-interactions": attributesValues } : undefined;
    }
}

const isEmpty = (val) => {
    return (val === undefined || val == null || val.length <= 0 || val == "null") ? true : false;
};

const ulid = (seedTime) => {
    const currPrng = () => Math.random();
    const TIME_LEN = 10;
    const RANDOM_LEN = 16;
    const TIME_MAX = Math.pow(2, 48) - 1;
    const ENCODING = "0123456789ABCDEFGHJKMNPQRSTVWXYZ"; // Crockford's Base32
    const ENCODING_LEN = ENCODING.length;

    const encodeTime = (now, len) => {
        if (isNaN(now)) {
            throw new Error(now + " must be a number");
        }
        if (now > TIME_MAX) {
            throw new Error("cannot encode time greater than " + TIME_MAX);
        }
        if (now < 0) {
            throw new Error("time must be positive");
        }
        if (Number.isInteger(now) === false) {
            throw new Error("time must be an integer");
        }
        let mod;
        let str = "";
        for (; len > 0; len--) {
            mod = now % ENCODING_LEN;
            str = ENCODING.charAt(mod) + str;
            now = (now - mod) / ENCODING_LEN;
        }
        return str;
    };

    const encodeRandom = (len, prng) => {
        let str = "";
        for (; len > 0; len--) {
            let rand = Math.floor(prng() * ENCODING_LEN);
            if (rand === ENCODING_LEN) {
                rand = ENCODING_LEN - 1;
            }
            const randomChar = ENCODING.charAt(rand);
            str = randomChar + str;
        }
        return str;
    };

    if (isNaN(seedTime)) {
        seedTime = Date.now();
    }
    return encodeTime(seedTime, TIME_LEN) + encodeRandom(RANDOM_LEN, currPrng);
};
